module.exports = __webpack_public_path__ + "img/box.8ca62ff8.svg";